// extracted by mini-css-extract-plugin
module.exports = {"RoomsPage":"Room_RoomsPage__3wQro","RoomsBackground":"Room_RoomsBackground__3kcmv"};